module.exports = __webpack_public_path__ + "img/diapositiva-16-1.f567cc9d.png";